export const PREFERRED_LANGUAGE_GATE = 'PortalsPlatform::SupportPreferredLanguage';
export const CREATE_SPACE_GATE = 'PortalsPlatform::UnifiedShell::CreateSpace';

// When ungated, top-level nav items are labeled with their portal instance's
// service-provided displayName (from PortalNavigationEntry) instead of the
// hardcoded getNavLabel(id) i18n string.
export const NAV_DISPLAY_NAME_GATE = 'PortalsPlatform::UnifiedShell::NavDisplayName';